// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__5DNGv","firstSectionElement":"styles_firstSectionElement__UlhkP"};